import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Login from './pages/Login';
import Register from './pages/Register';
import RegisterAngel from './pages/RegisterAngel';
import SubmitArt from './pages/SubmitArt';
import ShowcaseBrand from './pages/ShowcaseBrand';
import OurPhilosophy from './pages/OurPhilosophy';
import HowNanakiWorks from './pages/HowNanakiWorks';
import Donate from './pages/Donate';
import Dashboard from './pages/Dashboard';
import AngelDashboard from './pages/AngelDashboard';
import About from './pages/About';
import OrderSuccess from './pages/OrderSuccess';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/products" element={<Products />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/about" element={<About />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/register-angel" element={<RegisterAngel />} />
              <Route path="/submit-art" element={<SubmitArt />} />
              <Route path="/showcase-brand" element={<ShowcaseBrand />} />
              <Route path="/our-philosophy" element={<OurPhilosophy />} />
              <Route path="/how-nanaki-works" element={<HowNanakiWorks />} />
              <Route path="/donate" element={<Donate />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/order-success" element={<OrderSuccess />} />
              
              {/* Admin Routes */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin/dashboard"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
              
              {/* User Routes */}
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/angel-dashboard"
                element={
                  <ProtectedRoute requiredRole="angel">
                    <AngelDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
